<template>
  <div class="container-fluid mycontainer-fluid page-content">
    <div v-if="!isLoading" class="row">
      <div class="col-xs-12">
        <div class="container-flex container-flex-card row myrow">
          <div
            class="container-col col-xs-12 col-md-12 col-lg-12 mycol"
            style="margin-right: 0px;"
          >
            <div class="container-stl container-stl-card">
              <div class="container-stl-body">
                <div
                  class="col-xs-12 col-md-12 col-lg-8 col-matrix col-matrix-left"
                >
                  <div class="table-responsive">
                    <table
                      class="table-expert-matrix table-expert-matrix-sm stl-mb-30"
                    >
                      <thead>
                        <tr>
                          <th
                            rowspan="3"
                            class="stl-bold stl-vertical-bottom cnt"
                          >
                            №
                          </th>
                          <th
                            rowspan="3"
                            class="stl-bold stl-vertical-bottom cnt"
                          >
                            ФИО
                          </th>
                          <th rowspan="2"></th>
                          <th
                            :colspan="listQuestionConference.counts"
                            class="text-center stl-bold"
                          >
                            №, наименование вопроса/заявитель/заемщик
                          </th>
                          <th rowspan="2"></th>
                        </tr>
                        <tr class="tr-name-org">
                          <th
                            v-for="(item,
                            index) in listQuestionConference.items"
                            :key="index"
                          >
                            <a
                              href="javascript:void(0)"
                              class="stl-link-black"
                              @click="
                                openVoteWindowByQuestion(item.QUESTION.ID)
                              "
                            >
                              {{ item.QUESTION.QUESTION_NAME }}
                            </a>
                          </th>
                        </tr>
                        <tr class="tr-count-org">
                          <th class="stl-bold cnt">Заочно</th>
                          <th
                            v-for="(item,
                            index) in listQuestionConference.items"
                            :key="index"
                            class="cnt"
                          >
                            {{ item.QUESTION.UF_SORT }}
                          </th>
                          <th class="stl-bold">Примечание</th>
                        </tr>
                      </thead>
                      <tbody>
                        <!-- режим сортировки -->
                        <template
                          v-if="listQuestionConference.IS_SET_MODE_SORT_EXPERT"
                        >
                          <tr
                            v-for="(item1,
                            index1) in listQuestionConference.VOTE_ALL_USER_QUESTION_SORT"
                          >
                            <template v-for="(item, index) in item1">
                              <td class="cnt">{{ index1 + 1 }}</td>
                              <td>
                                <a
                                  class="stl-link-black"
                                  href="javascript:void(0)"
                                  @click="openVoteWindowByExpert(index)"
                                  >{{
                                    listQuestionConference.EXPERT_LIST[index]
                                  }}</a
                                >
                              </td>
                              <td>
                                <div class="df-ac">
                                  <label class="stl-check-box">
                                    <input
                                      class="stl-check-box-inp"
                                      type="checkbox"
                                      @change="setTypePositionVoteExpert(index)"
                                      v-if="
                                        listQuestionConference
                                          .VOTE_EXPERT_TYPE_POSITION[index]
                                      "
                                      v-model="
                                        listQuestionConference
                                          .VOTE_EXPERT_TYPE_POSITION[index]
                                          .UF_IS_ABSENTIA
                                      "
                                    />
                                    <span></span>
                                  </label>
                                </div>
                              </td>
                              <td v-for="item2 in item">
                                <span
                                  v-if="item2.RESULT.UF_RESULT_VOTE_ID == 1"
                                  class="td-item-vote item-vote-behind"
                                ></span>
                                <span
                                  v-if="item2.RESULT.UF_RESULT_VOTE_ID == 2"
                                  class="td-item-vote item-vote-against"
                                ></span>
                                <span
                                  v-if="item2.RESULT.UF_RESULT_VOTE_ID == 3"
                                  class="td-item-vote item-vote-abstain"
                                ></span>
                              </td>
                              <td>
                                <textarea-autosize
                                  class="i-main-style"
                                  style="min-height: 20px"
                                  v-model="
                                    listQuestionConference.LIST_COMMENT[index]
                                      .UF_COMMENT
                                  "
                                  placeholder="Примечание"
                                  @change.native="saveComment(index)"
                                />
                                <!--<textarea
                                  style="min-height: 20px"
                                  class="i-main-style"
                                  v-model="
                                    listQuestionConference.LIST_COMMENT[index]
                                      .UF_COMMENT
                                  "
                                  placeholder="Примечание"
                                  @change="saveComment(index)"
                                ></textarea>-->
                              </td>
                            </template>
                          </tr>
                        </template>
                        <template v-else>
                          <tr
                            v-for="(item,
                            index,
                            i) in listQuestionConference.VOTE_ALL_USER_QUESTION"
                          >
                            <td class="cnt">{{ i + 1 }}</td>
                            <td>
                              <a
                                class="stl-link-black"
                                href="javascript:void(0)"
                                @click="openVoteWindowByExpert(index)"
                                >{{
                                  listQuestionConference.EXPERT_LIST[index]
                                }}</a
                              >
                            </td>
                            <td>
                              <div class="df-ac">
                                <label class="stl-check-box">
                                  <input
                                    class="stl-check-box-inp"
                                    type="checkbox"
                                    @change="setTypePositionVoteExpert(index)"
                                    v-if="
                                      listQuestionConference
                                        .VOTE_EXPERT_TYPE_POSITION[index]
                                    "
                                    v-model="
                                      listQuestionConference
                                        .VOTE_EXPERT_TYPE_POSITION[index]
                                        .UF_IS_ABSENTIA
                                    "
                                  />
                                  <span></span>
                                </label>
                              </div>
                            </td>
                            <td v-for="item2 in item">
                              <span
                                v-if="item2.RESULT.UF_RESULT_VOTE_ID == 1"
                                class="td-item-vote item-vote-behind"
                              ></span>
                              <span
                                v-if="item2.RESULT.UF_RESULT_VOTE_ID == 2"
                                class="td-item-vote item-vote-against"
                              ></span>
                              <span
                                v-if="item2.RESULT.UF_RESULT_VOTE_ID == 3"
                                class="td-item-vote item-vote-abstain"
                              ></span>
                            </td>
                            <td>
                              <textarea-autosize
                                class="i-main-style"
                                style="min-height: 20px"
                                v-model="
                                  listQuestionConference.LIST_COMMENT[index]
                                    .UF_COMMENT
                                "
                                placeholder="Примечание"
                                @change.native="saveComment(index)"
                              />

                              <!--<textarea
                                style="min-height: 20px"
                                class="i-main-style"
                                v-model="
                                  listQuestionConference.LIST_COMMENT[index]
                                    .UF_COMMENT
                                "
                                placeholder="Примечание"
                                @change="saveComment(index)"
                              ></textarea>-->
                            </td>
                          </tr>
                        </template>
                      </tbody>
                      <tbody class="tfoot-result-golos">
                        <tr>
                          <td colspan="2" rowspan="3" style="font-size: 14px;">
                            Результаты
                            <br />
                            голосования
                          </td>
                          <td>За</td>
                          <td
                            v-for="result in listQuestionConference.VOTE_RESULT_BY_QUESTION"
                          >
                            {{ result[1] }}
                          </td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>Против</td>
                          <td
                            v-for="result in listQuestionConference.VOTE_RESULT_BY_QUESTION"
                          >
                            {{ result[2] }}
                          </td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>Возд.</td>
                          <td
                            v-for="result in listQuestionConference.VOTE_RESULT_BY_QUESTION"
                          >
                            {{ result[3] }}
                          </td>
                          <td></td>
                        </tr>
                      </tbody>
                      <tfoot class="tfoot-result-itog">
                        <tr>
                          <td
                            colspan="3"
                            rowspan="2"
                            class="td-result-itog-title"
                          >
                            Итоговое решение
                          </td>
                          <td
                            v-for="item in listQuestionConference.VOTE_TOTAL_RESULT"
                          >
                            <div class="list-vote-area">
                              <span
                                v-if="item.result == 1"
                                class="list-vote-checked"
                              >
                                <i class="item-vote-behind"></i>
                              </span>
                              <span
                                v-else-if="item.result == 2"
                                class="list-vote-checked"
                              >
                                <i class="item-vote-against"></i>
                              </span>
                              <span
                                v-else-if="item.result == 3"
                                class="list-vote-checked"
                              >
                                <i class="item-vote-abstain"></i>
                              </span>

                              <div class="list-vote-container">
                                <div
                                  v-for="sp in listQuestionConference.SP_TYPE_VOIСE"
                                  class="list-vote__item"
                                  @click="
                                    setTotalVoices(item.idQuestion, sp.ID)
                                  "
                                >
                                  <span
                                    :class="
                                      sp.UF_CODE == 'yes'
                                        ? 'list-vote__item-behind'
                                        : sp.UF_CODE == 'no'
                                        ? 'list-vote__item-against'
                                        : 'list-vote__item-abstain'
                                    "
                                  ></span>
                                  {{ sp.UF_NAME }}
                                </div>
                              </div>
                            </div>
                          </td>

                          <td></td>
                        </tr>
                        <tr>
                          <td
                            v-for="(item,
                            index) in listQuestionConference.items"
                            :key="index"
                          >
                            {{ item.QUESTION.UF_SORT }}
                          </td>
                          <td></td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 mycol">
                    <div class="completed-expert">
                      <div class="completed-expert-title">
                        Председатель совета
                      </div>
                      <div class="form-group">
                        <select
                          @change="changeIsPresident"
                          v-model="
                            listQuestionConference.UF_PRESIDENT_SOVET_USR_ID
                          "
                          class="form-control"
                        >
                          <option
                            v-for="(item,
                            index) in listQuestionConference.EXPERT_LIST"
                            :value="index"
                            :key="index"
                            v-text="item"
                          >
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col-xs-12 col-md-12 col-lg-4 col-matrix col-matrix-right"
                >
                  <div class="df-js-b matrix-expert-right">
                    <table class="table-clue-matrix">
                      <tbody>
                        <tr>
                          <td>За</td>
                          <td>
                            <span class="td-item-vote item-vote-behind"></span>
                          </td>
                        </tr>
                        <tr>
                          <td>Против</td>
                          <td>
                            <span class="td-item-vote item-vote-against"></span>
                          </td>
                        </tr>
                        <tr>
                          <td>Возд.</td>
                          <td>
                            <span class="td-item-vote item-vote-abstain"></span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="matrix-expert-right__controll">
                      <button
                        v-on:click="exportMatrix()"
                        class="butt-stl butt-blue"
                      >
                        печать матрицы голосования
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- container-col -->
        </div>
      </div>
    </div>

    <!-- Голосование от представителя -->
    <div
      class="modal fade in"
      :class="{ show: isViewVoteByExpertModal }"
      id="matrix-modal-representative"
      tabindex="-1"
      role="dialog"
    >
      <form>
        <div
          class="modal-dialog modal-new-style modal-close-active modal-dialog-lg"
          role="document"
        >
          <div
            class="modal-content"
            v-if="listQuestionConference.EXPERT_LIST[expertIdTemp]"
          >
            <div class="modal-header">
              <button
                type="button"
                class="close"
                @click="closeVoteWindowByExpert"
                aria-label="Close"
                data-dismiss="modal"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <div class="modal-title">
                Голосование:
                {{ listQuestionConference.EXPERT_LIST[expertIdTemp] }}
              </div>
            </div>
            <div class="modal-body" style="margin-bottom: 0px;">
              <div class="form-group">
                <div class="matrix-modal-content">
                  <div class="matrix-modal-content__title">Вопрос</div>
                  <table class="modal-table-expert">
                    <tbody>
                      <tr v-for="item in listQuestionConference.items">
                        <td class="stl-fw-bold">{{ item.QUESTION.UF_SORT }}</td>
                        <td class="stl-fw-bold">
                          {{ item.QUESTION.UF_NAME }}
                        </td>
                        <td>
                          <div class="vote-controll df-ac">
                            <button
                              v-for="(voice,
                              index) in listQuestionConference.SP_TYPE_VOIСE"
                              :key="index"
                              type="button"
                              class="butt-stl vote-controll-item butt-vote-behind"
                              :class="[
                                voice.UF_CLASS_BUTTON,
                                listQuestionConference.VOTE_ALL_USER &&
                                listQuestionConference.VOTE_ALL_USER[
                                  expertIdTemp
                                ] &&
                                listQuestionConference.VOTE_ALL_USER[
                                  expertIdTemp
                                ][item.QUESTION.ID] &&
                                listQuestionConference.VOTE_ALL_USER[
                                  expertIdTemp
                                ][item.QUESTION.ID].RESULT &&
                                listQuestionConference.VOTE_ALL_USER[
                                  expertIdTemp
                                ][item.QUESTION.ID].RESULT.UF_RESULT_VOTE_ID ===
                                  voice.ID
                                  ? 'active'
                                  : ''
                              ]"
                              @click="
                                setVoice(
                                  item.QUESTION.ID,
                                  voice.ID,
                                  listQuestionConference.VOTE_ALL_USER[
                                    expertIdTemp
                                  ][item.QUESTION.ID].RESULT.UF_RESULT_VOTE_ID,
                                  expertIdTemp
                                )
                              "
                            >
                              {{ voice.UF_NAME }}
                            </button>

                            <a
                              v-if="
                                listQuestionConference.VOTE_ALL_USER[
                                  expertIdTemp
                                ][item.QUESTION.ID].HISTORY &&
                                  listQuestionConference.VOTE_ALL_USER[
                                    expertIdTemp
                                  ][item.QUESTION.ID].HISTORY.length
                              "
                              @click="
                                openHistoryModal(expertIdTemp, item.QUESTION.ID)
                              "
                              class="icon-item status-history"
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody>
                      <tr>
                        <td></td>
                        <td></td>
                        <td>
                          <div class="vote-controll df-ac">
                            <button
                              v-for="(voice,
                              index) in listQuestionConference.SP_TYPE_VOIСE"
                              :key="index"
                              type="button"
                              :class="[voice.UF_CLASS_BUTTON]"
                              @click="
                                setVoiceAll(
                                  listQuestionConference.EXPERT_SOVET_ID,
                                  voice.ID,
                                  expertIdTemp
                                )
                              "
                              class="butt-stl vote-controll-item butt-vote-behind"
                            >
                              Все {{ voice.UF_NAME }}
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="matrix-modal-content-footer"></div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </form>
    </div>
    <!-- /.modal -->
    <!-- Голосование от представителя -->

    <!-- Голосование от организации -->
    <div
      class="modal fade in"
      :class="{ show: isViewVoteByQuestionModal }"
      id="matrix-modal-org"
      tabindex="-1"
      role="dialog"
    >
      <form>
        <div
          class="modal-dialog modal-new-style modal-close-active modal-dialog-lg"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                aria-label="Close"
                data-dismiss="modal"
                @click="closeVoteWindowByQuestion"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <div
                class="modal-title"
                v-if="
                  listQuestionConference.QUESTION_LIST_BY_ID[questionIdTemp]
                "
              >
                Голосование:
                {{
                  listQuestionConference.QUESTION_LIST_BY_ID[questionIdTemp]
                    .QUESTION_NAME
                }}
              </div>
            </div>
            <div class="modal-body" style="margin-bottom: 0px;">
              <div class="form-group">
                <div class="matrix-modal-content">
                  <div class="matrix-modal-content__title">ФИО</div>
                  <table class="modal-table-expert">
                    <tbody>
                      <tr
                        v-for="(expert,
                        index,
                        key) in listQuestionConference.VOTE_ALL_USER"
                      >
                        <td class="stl-fw-bold">{{ key + 1 }}</td>
                        <td class="stl-fw-bold">
                          {{ listQuestionConference.EXPERT_LIST[index] }}
                        </td>
                        <td>
                          <div class="vote-controll df-ac">
                            <button
                              v-for="(voice,
                              index2) in listQuestionConference.SP_TYPE_VOIСE"
                              :key="index2"
                              type="button"
                              class="butt-stl vote-controll-item butt-vote-behind"
                              :class="[
                                voice.UF_CLASS_BUTTON,
                                expert &&
                                expert[questionIdTemp] &&
                                expert[questionIdTemp].RESULT &&
                                expert[questionIdTemp].RESULT
                                  .UF_RESULT_VOTE_ID === voice.ID
                                  ? 'active'
                                  : ''
                              ]"
                              @click="
                                setVoice(
                                  questionIdTemp,
                                  voice.ID,
                                  expert[questionIdTemp].RESULT
                                    .UF_RESULT_VOTE_ID,
                                  index
                                )
                              "
                            >
                              {{ voice.UF_NAME }}
                            </button>
                            <a
                              v-if="
                                expert &&
                                  expert[questionIdTemp] &&
                                  expert[questionIdTemp].HISTORY &&
                                  expert[questionIdTemp].HISTORY.length
                              "
                              @click="openHistoryModal(index, questionIdTemp)"
                              class="icon-item status-history"
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tbody>
                      <tr>
                        <td></td>
                        <td></td>
                        <td>
                          <div class="vote-controll df-ac">
                            <button
                              v-for="(voice,
                              index) in listQuestionConference.SP_TYPE_VOIСE"
                              :key="index"
                              type="button"
                              :class="[voice.UF_CLASS_BUTTON]"
                              @click="
                                setVoiceAllExpertByQuestion(
                                  listQuestionConference.EXPERT_SOVET_ID,
                                  voice.ID,
                                  questionIdTemp
                                )
                              "
                              class="butt-stl vote-controll-item butt-vote-behind"
                            >
                              Все
                              {{
                                voice.ID == 3 ? "воздержались" : voice.UF_NAME
                              }}
                            </button>
                          </div>
                        </td>
                      </tr>
                    </tbody>

                    <tbody
                      v-if="
                        listQuestionConference.IS_VIEW_BUTTON_CHANGE_STATUS_PROJECT &&
                          listQuestionConference.QUESTION_LIST_BY_ID[
                            questionIdTemp
                          ]
                      "
                    >
                      <tr style="background-color: rgba(240, 241, 245, 0.5);">
                        <td></td>
                        <td class="stl-fw-bold">Статус проекта</td>
                        <td>
                          <div class="vote-controll df-ac">
                            <button
                              v-for="(voice,
                              index) in listQuestionConference.LIST_STATUS_CHANGE_PROJECT"
                              :key="index"
                              type="button"
                              :class="[
                                voice.UF_CLASS_BUTTON,
                                statusIdProjectTemp == voice.ID ||
                                listQuestionConference.QUESTION_LIST_BY_ID[
                                  questionIdTemp
                                ].STATUS.UF_STATUS_ID == voice.ID
                                  ? 'active'
                                  : '',
                                listQuestionConference.QUESTION_LIST_BY_ID[
                                  questionIdTemp
                                ].IS_BLOCK_STATUS == 1
                                  ? 'butt-vote-disabled'
                                  : ''
                              ]"
                              :disabled="
                                listQuestionConference.QUESTION_LIST_BY_ID[
                                  questionIdTemp
                                ].IS_BLOCK_STATUS == 1
                                  ? true
                                  : false
                              "
                              @click="setNewStatusProject(voice)"
                              class="butt-stl vote-controll-item butt-vote-behind"
                            >
                              {{ voice.NAME }}
                            </button>
                          </div>
                        </td>
                      </tr>
                      <tr
                        v-if="
                          isViewApprovedSumm ||
                            listQuestionConference.QUESTION_LIST_BY_ID[
                              questionIdTemp
                            ].IS_VIEW_SUM_APPROVED
                        "
                      >
                        <td></td>
                        <td class="stl-fw-bold">Одобренная сумма, тыс. руб.</td>
                        <td>
                          <vue-numeric
                            currency=""
                            separator="space"
                            output-type="Number"
                            type="text"
                            class="form-control vote-controll-item i-main-style"
                            style="width:160px;"
                            v-model="tempSumApproved"
                          />
                        </td>
                      </tr>
                      <tr v-if="isViewConfirmButton">
                        <td></td>
                        <td>
                          <button
                            v-on:click="setNewStatus()"
                            class="butt-stl butt-blue"
                            type="button"
                          >
                            подтвердить
                          </button>
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="matrix-modal-content-footer"></div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </form>
    </div>
    <!-- /.modal -->
    <!-- Голосование от организации -->

    <!-- История статусов голосования -->
    <div
      class="modal fade in"
      :class="{ show: isViewHistoryModal }"
      id="info-vote-modal"
      tabindex="-1"
      role="dialog"
    >
      <form>
        <div
          class="modal-dialog modal-new-style modal-close-active"
          role="document"
        >
          <div class="modal-content" v-if="elementTemp.QUESTION_NAME">
            <div class="modal-header">
              <button
                type="button"
                class="close"
                aria-label="Close"
                data-dismiss="modal"
                @click="closeHistoryModal"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <h4 class="modal-title">
                История статусов голосования по вопросу №
                {{ elementTemp.UF_SORT }}
                {{ elementTemp.QUESTION_NAME }}
              </h4>
              <h4 class="modal-title">
                Эксперт: {{ listQuestionConference.EXPERT_LIST[expertIdTemp] }}
              </h4>
            </div>
            <div class="modal-body" style="margin-bottom: 0px;">
              <div class="form-group">
                <div
                  v-for="(item, index) in historyStatusTemp"
                  :key="index"
                  class="info-vote-modal__history"
                >
                  <p>
                    {{ item.UF_TIMESTAMP_X }}
                    {{ listQuestionConference.EXPERT_LIST[item.UF_EXPERT_ID] }}
                    выбрал "{{ item.TYPE_VOICE_RESULT_NAME }}"
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </form>
    </div>
    <!-- /.modal -->
    <!-- История статусов голосования -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { FETCH_LIST_QUESTION_CONFERENCE } from "@/store/actions.type";
import { ExpertAdvice } from "@/common/api.service";
import { AUTH_URL } from "@/common/config";
import { ProjectsService } from "@/common/api.service";

export default {
  name: "VotingPage",
  data() {
    return {
      isViewVoteByExpertModal: false,
      isViewVoteByQuestionModal: false,
      expertIdTemp: 0,
      questionIdTemp: 0,
      historyTempStatus: "",
      isViewHistoryModal: false,
      elementTemp: "",
      statusIdProjectTemp: 0,
      statusCodeProjectTemp: "",
      isViewConfirmButton: false,
      tempSumApproved: 0,
      isViewApprovedSumm: false,
      filter: {
        MODE: "voting"
      },
      isLoading: false
    };
  },
  computed: {
    ...mapGetters([
      "questions",
      "isQuestionsLoading",
      "listQuestionConference",
      "isListQuestionConference",
      "directory",
      "currentUser"
    ])
  },
  async mounted() {
    this.fetchItems();

    const query = Object.assign({}, this.$route.query);
    if (query.mode) {
      delete query.mode;
      this.$router.replace({ query });
    }
  },
  methods: {
    moveBack() {
      this.$router.push({
        name: "EAList",
        params: { id: this.$route.params.id }
      });
    },
    fetchItems() {
      this.isLoading = true;
      this.$store
        .dispatch(FETCH_LIST_QUESTION_CONFERENCE, {
          idSovet: this.$route.params.id,
          filter: { ...this.filter }
        })
        .then(() => {
          document.title = unescape(this.listQuestionConference.TITLE_PAGE);
          this.isLoading = false;
        }, this);
    },
    changeIsPresident() {
      ExpertAdvice.setPresidentSovet(
        this.listQuestionConference.EXPERT_SOVET_ID,
        {
          UF_PRESIDENT_SOVET_USR_ID: this.listQuestionConference
            .UF_PRESIDENT_SOVET_USR_ID
        }
      ).then(({ data }) => {
        if (data.errorArr && data.errorArr.length) {
          this.$toasted.show(data.errorArr[0].TEXT, {
            theme: "red",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          this.$toasted.show("Председатель совета успешно установлен", {
            theme: "green",
            position: "bottom-right",
            duration: 3500
          });
          // this.fetchItems();
        }
      }, this);
    },
    setTotalVoices(idQustion, idVoices) {
      ExpertAdvice.setTotalVoices(idQustion, {
        UF_RESULT_VOTE_ID: idVoices
      }).then(({ data }) => {
        if (data.errorArr && data.errorArr.length) {
          this.$toasted.show(data.errorArr[0].TEXT, {
            theme: "red",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          this.$toasted.show(
            "Итоговое решение по выбранному вопросу установлено",
            {
              theme: "green",
              position: "bottom-right",
              duration: 3500
            }
          );
          this.fetchItems();
        }
      }, this);
    },
    setTypePositionVoteExpert(idExpert) {
      ExpertAdvice.setTypePositionVoteExpert(
        this.listQuestionConference.EXPERT_SOVET_ID,
        {
          UF_IS_ABSENTIA: this.listQuestionConference.VOTE_EXPERT_TYPE_POSITION[
            idExpert
          ].UF_IS_ABSENTIA,
          UF_EXPERT_ID: idExpert
        }
      ).then(({ data }) => {
        if (data.errorArr && data.errorArr.length) {
          this.$toasted.show(data.errorArr[0].TEXT, {
            theme: "red",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          this.$toasted.show("Признак голосования 'Заочно' изменен", {
            theme: "green",
            position: "bottom-right",
            duration: 3500
          });
          //this.fetchItems();
        }
      }, this);
    },
    openVoteWindowByExpert(idExpert) {
      this.isViewVoteByExpertModal = true;
      this.expertIdTemp = idExpert;
    },
    closeVoteWindowByExpert() {
      this.isViewVoteByExpertModal = false;
    },
    setVoice(id, vote, voteLastID, expertId) {
      if (vote != voteLastID) {
        ExpertAdvice.setVoice(id, {
          UF_RESULT_VOTE_ID: vote,
          UF_EXPERT_ID: expertId
        }).then(({ data }) => {
          if (data.errorArr && data.errorArr.length) {
            this.$toasted.show(data.errorArr[0].TEXT, {
              theme: "red",
              position: "bottom-right",
              duration: 3500
            });
          } else {
            this.fetchItems();
          }
        }, this);
      }
    },
    setVoiceAll(idSovet, vote, expertId) {
      ExpertAdvice.setVoiceAll(idSovet, {
        UF_RESULT_VOTE_ID: vote,
        UF_EXPERT_ID: expertId
      }).then(({ data }) => {
        if (data.errorArr && data.errorArr.length) {
          this.$toasted.show(data.errorArr[0].TEXT, {
            theme: "red",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          this.fetchItems();
        }
      }, this);
    },
    setVoiceAllExpertByQuestion(idSovet, vote, questionIdTemp) {
      ExpertAdvice.setVoiceAllExpertByQuestion(idSovet, {
        UF_RESULT_VOTE_ID: vote,
        UF_QUESTION_ID: questionIdTemp
      }).then(({ data }) => {
        if (data.errorArr && data.errorArr.length) {
          this.$toasted.show(data.errorArr[0].TEXT, {
            theme: "red",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          this.fetchItems();
        }
      }, this);
    },
    openVoteWindowByQuestion(idQuestion) {
      this.isViewVoteByQuestionModal = true;
      this.questionIdTemp = idQuestion;
      this.statusIdProjectTemp = 0;
      this.statusCodeProjectTemp = "";
      this.isViewConfirmButton = false;
      this.isViewApprovedSumm = false;

      this.tempSumApproved = this.listQuestionConference.QUESTION_LIST_BY_ID[
        this.questionIdTemp
      ].PROJECT_UF_SUM_APPROVED;
    },
    closeVoteWindowByQuestion() {
      this.isViewVoteByQuestionModal = false;
    },
    openHistoryModal(expertId, idQuestion) {
      this.historyStatusTemp = this.listQuestionConference.VOTE_ALL_USER[
        expertId
      ][idQuestion].HISTORY;
      this.elementTemp = this.listQuestionConference.QUESTION_LIST_BY_ID[
        idQuestion
      ];
      this.isViewHistoryModal = true;
      this.expertIdTemp = expertId;
      console.log(this.elementTemp);
    },
    closeHistoryModal() {
      this.isViewHistoryModal = false;
    },
    exportMatrix() {
      ExpertAdvice.getLinkPrintMatrixExcel(
        this.listQuestionConference.EXPERT_SOVET_ID
      ).then(({ data }) => {
        window.location.href =
          AUTH_URL.replace(new RegExp("[\\/]+$"), "") + data.link;
      });
    },
    setNewStatusProject(status) {
      console.log(status);
      this.statusIdProjectTemp = status.ID;
      this.statusCodeProjectTemp = status.CODE;
      this.isViewConfirmButton = true;
      this.isViewApprovedSumm =
        status.CODE == "approved_expert_sovet" ? true : false;

      this.tempSumApproved =
        this.listQuestionConference.QUESTION_LIST_BY_ID[this.questionIdTemp]
          .PROJECT_UF_SUM_APPROVED == 0
          ? this.listQuestionConference.QUESTION_LIST_BY_ID[this.questionIdTemp]
              .PROJECT_UF_SUM_REQUEST
          : this.listQuestionConference.QUESTION_LIST_BY_ID[this.questionIdTemp]
              .PROJECT_UF_SUM_APPROVED;
    },
    setNewStatus() {
      if (
        this.listQuestionConference.QUESTION_LIST_BY_ID[this.questionIdTemp]
          .UF_PROJECT_ID > 0
      ) {
        ProjectsService.setNewStatusProjectBySecterary(
          this.listQuestionConference.QUESTION_LIST_BY_ID[this.questionIdTemp]
            .UF_PROJECT_ID,
          {
            UF_STATUS_ID: this.statusIdProjectTemp,
            UF_SUM_APPROVED: this.tempSumApproved
          }
        ).then(({ data }) => {
          if (data.errorArr && data.errorArr.length) {
            data.errorArr.forEach(function(text) {
              this.$toasted.show(text.TEXT, {
                theme: "red",
                position: "bottom-right",
                duration: 3500
              });
            }, this);
          } else {
            this.fetchItems();
            this.isViewConfirmButton = false;
            this.$toasted.show("Статус проекта успешно изменен", {
              theme: "green",
              position: "bottom-right",
              duration: 5000
            });
          }
        }, this);
      } else {
        this.$toasted.show("В вопросе не указан проект", {
          theme: "red",
          position: "bottom-right",
          duration: 3500
        });
      }
    },
    saveComment(idExpert) {
      ExpertAdvice.setCommentExpertBySovet(
        this.listQuestionConference.EXPERT_SOVET_ID,
        {
          UF_COMMENT: this.listQuestionConference.LIST_COMMENT[idExpert]
            .UF_COMMENT,
          UF_EXPERT_ID: idExpert
        }
      ).then(({ data }) => {
        if (data.errorArr && data.errorArr.length) {
          this.$toasted.show(data.errorArr[0].TEXT, {
            theme: "red",
            position: "bottom-right",
            duration: 3500
          });
        } else {
          this.$toasted.show(
            "Примечание к голосованию эксперта '" +
              this.listQuestionConference.EXPERT_LIST[idExpert] +
              "' сохранено",
            {
              theme: "green",
              position: "bottom-right",
              duration: 3500
            }
          );
          //this.fetchItems();
        }
      }, this);
    }
  }
};
</script>
